import React from 'react';
import type { BallInfo } from '../types/lottery';
import { getBallColor } from '../utils/ball';
import { withFontOffset } from '../utils/font';
import './LotteryBall.css';

interface Props {
  ball: BallInfo;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  showSx?: boolean;
  isSpecial?: boolean;
  reveal?: boolean;
  revealDelayMs?: number;
}

const LotteryBall: React.FC<Props> = ({
  ball,
  size = 'md',
  showSx = true,
  isSpecial = false,
  reveal = false,
  revealDelayMs = 0,
}) => {
  const bgColor = getBallColor(ball.class);
  const sizeMap = { xs: 24, sm: 32, md: 40, lg: 52 };
  const fontMap = { xs: 11, sm: 13, md: 16, lg: 20 };
  const dim = sizeMap[size];

  return (
    <div
      className={`lottery-ball-wrap ${isSpecial ? 'special' : ''}${reveal ? ' is-revealing' : ''}`}
      style={reveal ? { animationDelay: `${revealDelayMs}ms` } : undefined}
    >
      <div
        className="lottery-ball"
        style={{
          width: dim,
          height: dim,
          background: ball.class === '0'
            ? '#ddd'
            : `radial-gradient(circle at 35% 35%, ${bgColor}dd, ${bgColor})`,
          fontSize: withFontOffset(fontMap[size]),
        }}
      >
        {ball.title}
      </div>
      {showSx && <div className="ball-sx">{ball.sx?.name || ''} / {ball.sx?.wuxing || ''}</div>}
    </div>
  );
};

export default LotteryBall;
